export default __webpack_public_path__ + "static/media/steps-black.070ce03a.svg";